import React, { ReactNode } from "react";
import { BRAND_GRADIENT_TRACK } from "@/components/ui/brandGradient";
import { cn } from "@/utils/cn";

const SIZES = {
  sm: { gap: "gap-2", chip: "w-6 h-6 text-xs" },
  md: { gap: "gap-3", chip: "w-9 h-9 text-sm" },
} as const;

interface ClientBadgeProps {
  name: string;
  /** "md" in the clients table, "sm" in panel group headers. */
  size?: keyof typeof SIZES;
  /** Extra lines under the name (the clients table's profile line and links). */
  meta?: ReactNode;
  className?: string;
}

/**
 * The client's identity (DD-049): a round initial on the brand wash
 * (DD-012), then the name. Shared by the clients table and the agency
 * Tasks tab group headers.
 */
export function ClientBadge({ name, size = "md", meta, className }: ClientBadgeProps) {
  const { gap, chip } = SIZES[size];
  return (
    <div className={cn("flex items-center", gap, className)}>
      <span
        className={`flex items-center justify-center ${chip} rounded-full ${BRAND_GRADIENT_TRACK} font-bold text-gray-700 shrink-0`}
      >
        {name.trim().charAt(0).toUpperCase()}
      </span>
      <div className="min-w-0">
        <div className="text-sm font-medium text-gray-900 truncate">{name}</div>
        {meta}
      </div>
    </div>
  );
}
